import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ValidationContext } from './validationContext'
import { useLocalization } from '@/hooks/localization'

const ValidationBoundary = React.memo(function ValidationBoundary ({ serverError, children }) {
  const { localize, locale } = useLocalization()
  const [errors, setErrors] = useState([])

  function onValidate (error) {
    const prevError = errors.find(x => x.field === error.field)
    if (prevError) {
      if (!error.error) { // remove error
        setErrors(errors => errors.filter(x => x.field !== error.field))
      } else { // update error
        setErrors(errors => errors.map(e => e.field === error.field ? error : e))
      }
    } else if (error.error) { // add error
      setErrors(errors => [ ...errors, error ])
    }
  }

  function resetErrors (names) {
    setErrors(errors => errors.filter(x => !names.includes(x.field)))
  }

  return (
    <ValidationContext.Provider value={{ errors, localize, locale, serverError, onValidate, resetErrors }}>
      {children}
    </ValidationContext.Provider>
  )
})

ValidationBoundary.propTypes = {
  children: PropTypes.node,
  serverError: PropTypes.object
}

export {
  ValidationBoundary
}



// WEBPACK FOOTER //
// ./src/components/validation/validationBoundary.js